var React = require('react');

function UiArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow Right"),React.createElement("path",{"d":"M37.6,20.8L22.5,35.8c-1.3,1.3-3.4,1.3-4.7,0s-1.3-3.4,0-4.7l0,0l9.4-9.4H3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3\n\th23.9l-9.4-9.4c-1.3-1.3-1.3-3.4,0-4.7c1.3-1.3,3.4-1.3,4.7,0l15.1,15.1C38.9,17.3,38.9,19.5,37.6,20.8\n\tC37.6,20.8,37.6,20.8,37.6,20.8z","key":1})]);
}

UiArrowRight.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 38.6 36.8","style":{"enableBackground":"new 0 0 38.6 36.8"},"xmlSpace":"preserve"};

module.exports = UiArrowRight;

UiArrowRight.default = UiArrowRight;
